import type { ActivityType } from '../types'
import type { RelationRef } from './types'

/** Drafts survive Escape, a tab switch and a reload (IA-15, ED-52); storage never throws. */
export function readDraft<T>(key: string, isValid: (value: unknown) => value is T): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (raw === null) return null
    const value: unknown = JSON.parse(raw)
    return isValid(value) ? value : null
  } catch {
    return null
  }
}

export function writeDraft(key: string, value: unknown): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Without storage the draft lives as long as the page.
  }
}

export function clearDraft(key: string): void {
  try {
    sessionStorage.removeItem(key)
  } catch {
    // Nothing to clear.
  }
}

export function composerDraftKey(relation: RelationRef, type: ActivityType): string {
  return `crm:composer:${relation.kind}:${relation.id}:${type}`
}

export function taskDraftKey(relation: RelationRef): string {
  return `crm:taak:${relation.kind}:${relation.id}`
}
